import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Staff Analytics — Owner
 * GET /staff/analytics?period=month|year|all
 */
export const getStaffAnalytics = async (period = "year") => {
  const res = await axiosInstance.get("/staff/analytics", {
    params: { period },
  });
  return res.data;
};

/**
 * Staff Analytics — Portal
 * GET /staff-portal/analytics?period=month|year|all
 */
export const getStaffAnalyticsPortal = async (period = "year") => {
  const res = await axiosInstance.get("/staff-portal/analytics", {
    params: { period },
  });
  return res.data;
};

const staffAnalyticsApi = {
  getStaffAnalytics,
  getStaffAnalyticsPortal,
};

export default staffAnalyticsApi;